export function ClientReducer(state = [], action) {
    const { type, payload } = action;

    switch (type) {
      case "GET_CLIENTS_INIT":
        return [];
      case "GET_CLIENTS_SUCCESS":
        return payload;
      default:
        return state;
    }
}

export function AllClientReducer(state = [], action) {
  const { type, payload } = action;

  switch (type) {
    case "GET_ALL_CLIENTS_INIT":
      return [];
    case "GET_ALL_CLIENTS_SUCCESS":
      return payload;
    default:
      return state;
  }
}

export function AssignedClientsReducer(state = [], action) {
  const { type, payload } = action;

  switch (type) {
    case "GET_ASSIGNED_CLIENTS_INIT":
      return [];
    case "GET_ASSIGNED_CLIENTS_SUCCESS":
      return payload;
    case "UPDATE_ASSIGNED_CLIENTS_SUCCESS":
      return payload;
    default:
      return state;
  }
}
